import { useState } from "react";
import { FiFilter, FiPlus, FiX } from "react-icons/fi";
import { MdCalendarToday } from "react-icons/md";
import { IoFilterCircle } from "react-icons/io5";
import { Link } from "react-router-dom";

// Dummy data
const expenseData = [
  { type: "Tax", vendor: "John DoE", phone: "+91 9566546542" },
  { type: "Fuel", vendor: "John DoE", phone: "+91 9566546542" },
  { type: "Food", vendor: "John DoE", phone: "+91 9566546542" },
  { type: "Bill", vendor: "John DoE", phone: "+91 9566546542" },
];

const incomeData = [
  { type: "Salary", source: "Company XYZ" },
  { type: "Freelance", source: "Client ABC" },
];

const ExpenseIncome = () => {
  const [activeTab, setActiveTab] = useState("Expense");
  const [filterOpen, setFilterOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [search, setSearch] = useState("");

  const filteredExpense = expenseData.filter((d) =>
    d.type.toLowerCase().includes(search.toLowerCase())
  );

  const filteredIncome = incomeData.filter((d) =>
    d.type.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="mx-auto p-4 text-gray-800">
      <h1 className="text-lg font-semibold mb-4">Expense / Income</h1>

      {/* Tabs */}
      <div className="flex border rounded-full overflow-hidden mb-3">
        {["Expense", "Income"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`flex-1 py-2 text-sm font-medium ${
              activeTab === tab
                ? "bg-primary text-white"
                : "bg-gray-100 text-gray-700"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Search and Filter */}
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          placeholder="Search"
          className="w-[90%] px-4 py-2 border rounded text-sm"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button onClick={() => setFilterOpen(true)}>
          <IoFilterCircle className="text-primary text-4xl" />
        </button>
      </div>

      {/* List */}
      <div className="space-y-3">
        {activeTab === "Expense"
          ? filteredExpense.map((item, idx) => (
              <Link
                to="/expensedetail"
                key={idx}
                className="flex items-center justify-between bg-white px-4 py-3 rounded shadow cursor-pointer"
              >
                <div className="flex items-center gap-3">
                  <div className="bg-primary text-white w-8 h-8 flex items-center justify-center rounded-full text-sm font-semibold">
                    {item.type[0]}
                  </div>
                  <div>
                    <div className="text-sm font-medium">{item.type}</div>
                    <div className="text-xs text-gray-500">
                      Vendor: {item.vendor}
                      <br />
                      {item.phone}
                    </div>
                  </div>
                </div>
              </Link>
            ))
          : filteredIncome.map((item, idx) => (
              <Link to="/incomedetail"
                key={idx}
                className="flex items-center justify-between bg-white px-4 py-3 rounded shadow"
              >
                <div className="flex items-center gap-3">
                  <div className="bg-green-600 text-white w-8 h-8 flex items-center justify-center rounded-full text-sm font-semibold">
                    {item.type[0]}
                  </div>
                  <div>
                    <div className="text-sm font-medium">{item.type}</div>
                    <div className="text-xs text-gray-500">
                      Source: {item.source}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
      </div>

      {/* Floating Add Button */}
      <button
        onClick={() => setAddOpen(true)}
        className="fixed bottom-6 right-6 bg-primary text-white p-4 rounded-full shadow-md"
      >
        <FiPlus size={20} />
      </button>

      {/* Add Popup */}
      {addOpen && (
        <Modal
          title={`Add ${activeTab}`}
          onClose={() => setAddOpen(false)}
        >
          {activeTab === "Expense" ? (
            <>
              <FormGroup label="Expense Category" placeholder="Enter Expense Category" />
              <FormGroup label="Expense Type" placeholder="Enter Expense Type" />
              <FormGroup label="Vendor Name" placeholder="Enter Vendor Name" />
              <FormGroup
                label="Vendor Mobile Number"
                placeholder="Enter Vendor Mobile Number"
              />
            </>
          ) : (
            <>
              <FormGroup label="Income Category" placeholder="Enter Income Category" />
              <FormGroup label="Income Type" placeholder="Enter Income Type" />
            </>
          )}
          <button className="bg-primary text-white w-full py-2 rounded mt-4">
            Save
          </button>
        </Modal>
      )}
    </div>
  );
};

// Modal Component
const Modal = ({ onClose, title, children }) => (
  <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
    <div className="bg-white w-full max-h-[90vh] overflow-y-auto max-w-md mx-4 rounded-lg p-6 relative">
      <button
        onClick={onClose}
        className="absolute right-4 top-4 text-gray-500"
      >
        <FiX size={20} />
      </button>
      <h3 className="text-lg font-semibold text-center mb-4">{title}</h3>
      {children}
    </div>
  </div>
);

// Reusable Input Component
const FormGroup = ({ label, placeholder = "", type = "text", icon = null }) => (
  <div className="mb-3">
    <label className="text-sm font-medium block mb-1">{label}</label>
    <div className="flex items-center border rounded px-3">
      <input
        type={type}
        placeholder={placeholder}
        className="w-full py-2 text-sm outline-none"
      />
      {icon && <div className="ml-2">{icon}</div>}
    </div>
  </div>
);

export default ExpenseIncome;

